import React, { useEffect, useState } from 'react'
import { useUserStore } from '../../../../../store/useUserStore';
import { DataSelectType } from '../../../../../models/DataSelectType';
import { ticketMasterArray } from '../../../../../enums/ticketMaster';
import { getRecentYears } from '../../../../../common/GlobalFunctions';
import useUsers from '../../../../../store/ReactQueries/users/useUser';
import DinamicSelectComp from '../../../../../common/DinamicSelectComp';
import DinamicInputFilter from '../../../../../common/DinamicInputFilter';
import useStatuses from '../../../../../store/ReactQueries/statuses/useStatus';
import useCategory from '../../../../../store/ReactQueries/categories/useCategory';
import usePriorities from '../../../../../store/ReactQueries/priorities/usePriority';
import useCompany from '../../../../../store/ReactQueries/general/company/useCompany';
import useDepartment from '../../../../../store/ReactQueries/departments/useDepartment';
import useContractors from '../../../../../store/ReactQueries/contractors/useContractor';
import useCustomerByCompId from '../../../../../store/ReactQueries/customers/useCustomerByCompId';
import useLocationsByCompId from '../../../../../store/ReactQueries/locations/useLocationByCompId';
import useInterventionTypes from '../../../../../store/ReactQueries/interventionTypes/useInterventionType';

interface TicketFiltersProps {
    resetTrigger: number;
    filterData: DataSelectType[] | undefined;
    setFilterData: React.Dispatch<React.SetStateAction<DataSelectType[] | undefined>>;
}

interface RenderFiltersInterface {
    fieldDisplayName: string,
    optionsData: any[] | undefined,
    menuPlacement?: "top" | "bottom";
}
export const TicketFilters: React.FC<TicketFiltersProps> = ({ filterData, resetTrigger, setFilterData }) => {

    const { user } = useUserStore();
    const [companyId, setCompanyId] = useState<string>();

    const role =
        user?.["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
    const isAdminRole = role === "Admin";

    useEffect(() => {
        const companyItem = filterData?.find(item => item.field === "CompanyId");
        setCompanyId(companyItem ? companyItem.value : undefined);
    }, [JSON.stringify(filterData)]);

    useEffect(() => {
        let result = filterData?.filter(item => item.field !== 'LocationId' && item.field !== 'CustomerId');
        setFilterData(result);
    }, [companyId]);

    const { data: users } = useUsers(0, 0);
    const { data: statuses } = useStatuses(0, 0);
    const { data: companies } = useCompany(0, 0);
    const { data: categories } = useCategory(0, 0);
    const { data: priorities } = usePriorities(0, 0);
    const { data: departments } = useDepartment(0, 0);
    const { data: contractors } = useContractors(0, 0);
    const { data: interventionTypes } = useInterventionTypes(0, 0);
    const { data: customers } = useCustomerByCompId(0, 0, companyId);
    const { data: locations } = useLocationsByCompId(0, 0, companyId);

    let renderFilters: RenderFiltersInterface[] = [
        { fieldDisplayName: 'Tickets', optionsData: ticketMasterArray },
        { fieldDisplayName: 'Year', optionsData: getRecentYears },
        { fieldDisplayName: 'Status', optionsData: statuses },
        { fieldDisplayName: 'Priority', optionsData: priorities },
        { fieldDisplayName: 'InterventionType', optionsData: interventionTypes },
        { fieldDisplayName: 'Company', optionsData: companies, menuPlacement: 'top' },
        { fieldDisplayName: 'Location', optionsData: locations, menuPlacement: 'top' },
        { fieldDisplayName: 'Customer', optionsData: customers, menuPlacement: 'top' },
        { fieldDisplayName: 'Category', optionsData: categories, menuPlacement: 'top' },
        { fieldDisplayName: 'Department', optionsData: departments, menuPlacement: 'top' },
        { fieldDisplayName: 'Contractor', optionsData: contractors, menuPlacement: 'top' },
    ];

    if (isAdminRole) {
        renderFilters.unshift({
            fieldDisplayName: 'AssignedTo',
            optionsData: users?.map(({ id, firstname, lastname }) => ({ id, title: `${firstname ?? ''} ${lastname ?? ''}` }))
        });
    }

    return <React.Fragment>
        <DinamicInputFilter
            field="TicketNo"
            fieldDisplayName="TicketNo"
            filterData={filterData}
            resetTrigger={resetTrigger}
            setFilterData={setFilterData}
        />
        <DinamicInputFilter
            field="Title"
            fieldDisplayName="Title"
            filterData={filterData}
            resetTrigger={resetTrigger}
            setFilterData={setFilterData}
        />
        {
            renderFilters.map(item =>
                <DinamicSelectComp
                    key={`${item.fieldDisplayName}-ticket-filter`}
                    companyId={companyId}
                    filterData={filterData}
                    resetTrigger={resetTrigger}
                    optionsData={item.optionsData}
                    menuPlacement={item.menuPlacement}
                    fieldDisplayName={item.fieldDisplayName}
                    setFilterData={setFilterData}
                />)
        }
    </React.Fragment>
}
export default TicketFilters